export const languageOptions = [
  {
    title: 'france',
    url: '/fr-fr',
  },
  {
    title: 'us',
    url: '/en-us',
  },
  {
    title: 'international',
    url: '/en',
  },
]
